import type { ReactNode } from 'react';
import { Box } from '@mui/material';

interface TabPanelProps {
  children: ReactNode;
  value: number;
  index: number;
}

export function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      id={`notification-tabpanel-${index}`}
      aria-labelledby={`notification-tab-${index}`}
    >
      <Box sx={{ pt: 2, display: value !== index ? 'none' : undefined }}>
        {children}
      </Box>
    </div>
  );
}
